import React from 'react';
import { Link } from 'react-router-dom';

import styles from './MiniRankItemButtonStyles';

import Button from 'buyside/components/presentation/Button/button';

const MiniRankItemButton = ({ rank, currentCategory, size }) => {
  if (!rank) {
    return null;
  }
  const isActive = rank.category === currentCategory;
  const rankInfo = rank.rankString.split(' ');
  return (
    <Button url={`#${rank.category}`} size={size}>
      {({ linkStyles }) => {
        return (
          <Link
            to={`/${rank.category}`}
            disabled={isActive}
            className={`${linkStyles} ${styles.buttonText}`}
          >
            Best <span className={styles.rankNumber}>{rankInfo[0]}</span>{' '}
            {rankInfo.slice(1).join(' ')}
          </Link>
        );
      }}
    </Button>
  );
};

export default MiniRankItemButton;
